import { useState } from 'react';
import useSurveyService from './userSurveyServices';
import { useSearchParams } from 'react-router-dom';

const useEngagementSurvey = () => {
    const { getEngagementSurveyQuestions, submitEngagementSurvey } = useSurveyService();
  
    const [questions, setQuestions] = useState([]);
    const [displayMessage, setDisplayMessage] = useState('The Encompass Group Survey');
    const [bannerText, setBannerText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [surveyName, setSurveyName] = useState('');
    const [surveyFName, setSurveyFName] = useState('');
    const [surveyLName, setSurveyLName] = useState('');

    const [searchParams] = useSearchParams();
    const queryNamedSurveyId = searchParams.get('id');
    
    const [namedSurveyId, setNamedSurveyId] = useState(queryNamedSurveyId);

    async function getSurveyQuestionsForId() {
        try {
            if(emailAddress !== undefined && emailAddress !== null && emailAddress !== ''){
                setIsError(true);
                setDisplayMessage('The Encompass Group Survey');
                setBannerText('');
                setIsLoading(true);
                const questionResponse = await getEngagementSurveyQuestions(emailAddress, namedSurveyId); 
                const question = questionResponse.data;
                setQuestions(question.questions);
                setIsError(question.isError);
                if (question.isError) {
                    setDisplayMessage(question.displayMessage);
                }
            }

       }
        catch (error) {
            console.log(error);
            setIsError(true);
            setDisplayMessage(error.message);
            setQuestions([]);
        }
        finally {
            setIsLoading(false);
        }
    }

    async function submit(emailAddress, surveyFName, surveyLName, questions) {
        try {            
            setIsError(true);
            setDisplayMessage('Your Encompass Group Survey has been submitted.');
            setIsLoading(true);
            await submitEngagementSurvey(emailAddress, '', surveyFName, surveyLName, questions, namedSurveyId);
            setQuestions([]);
        }
        catch (error) {
            console.log(error);
            setIsError(true);
            setDisplayMessage('Request failed. Please try back later');
            setQuestions([]);
        }
        finally {
            setIsLoading(false);
        }
    }

    return {
        emailAddress,
        setEmailAddress,
        surveyName,
        setSurveyName,
        surveyFName,
        setSurveyFName,
        surveyLName,
        setSurveyLName,
        bannerText,
        questions,
        displayMessage,
        isLoading,
        isError,
        getSurveyQuestionsForId,
        setQuestions,
        submit,
        namedSurveyId, 
        setNamedSurveyId
    }

};

export default useEngagementSurvey;